export function hotspotPreviewVariables({ sourceImageWidth, sourceMarkerWidth, sourceLayoutWidth, sourceFontSize, previewImageWidth }) {
  if ([sourceImageWidth, sourceMarkerWidth, sourceLayoutWidth, sourceFontSize, previewImageWidth].some((value) => !Number.isFinite(value) || value <= 0)) return {};
  const diameter = previewImageWidth * sourceMarkerWidth / sourceImageWidth;
  const scale = diameter / sourceLayoutWidth;
  return {
    '--hotspot-preview-size': `${diameter}px`,
    '--hotspot-preview-font-size': `${sourceFontSize * scale}px`,
    '--hotspot-preview-scale': scale,
  };
}
